// Parents production Play package uses the registered parent OAuth callback.
export const getNativeParentOAuthCallbackUrl = () => 'mypiggyparents://auth/callback';
